import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectAvatar from "./MultiSelectAvatar";
import { egSelection } from "../../../actions/eg-kanban";
import { usePermission, isToday } from "../../../helpers/common";

const EGSelection = () => {
    const dispatch = useDispatch();
    const farmId = useSelector((state) => state.egKanban.filters.farmId);
    const refresh = useSelector((state) => state.egKanban.refresh);
    const egList = useSelector((state) => state.egKanban.egList);
    const kanban = useSelector((state) => state.egKanban.kanban);
    const newEgList = useSelector((state) => state.egKanban.newEgList);
    const columns = useSelector((state) => state.egKanban.columns);
    const range = useSelector((state) => state.analyze.searchParams.range);

    const selected = columns.filter(e => e.egId !== null).map(e => e.egId);
    const changedEg = Object.keys(kanban).filter(egId =>
        egId && kanban[egId] && kanban[egId].hasOwnProperty("isChanged") ? kanban[egId].isChanged : false);

    const allow = usePermission();
    const isAllowAdd = allow("equipment-group", "create") ? isToday(range) : false;

    const onSelect = (item, checked) => {
        const selectedOpt = [...selected];
        if (checked) selectedOpt.push(item.id);
        else selectedOpt.splice(selectedOpt.indexOf(item.id), 1);
        dispatch(egSelection(selectedOpt));
    };

    useEffect(() => {
        if (!farmId) return;
        if (egList.length > 0) {
            let currentSelected = egList
                .filter(e => selected.indexOf(e.equipment_group_uuid) >= 0)
                .map(e => e.equipment_group_uuid);

            if (currentSelected.length < 8) {
                const restCrews = egList.filter(e => currentSelected.indexOf(e.equipment_group_uuid) < 0);
                const maxCount = ((isAllowAdd ? 7 : 8) - currentSelected.length);
                const topSelected = (restCrews.length > 0) ?
                    restCrews
                        .slice(0, restCrews.length >= maxCount ? maxCount : restCrews.length)
                        .map(e => e.equipment_group_uuid) : [];
                currentSelected = [...currentSelected, ...topSelected];
            }
            dispatch(egSelection(currentSelected));
        } else if (selected.length > 0) {
            dispatch(egSelection([]));
        }
    }, [refresh, farmId, egList]);

    const oldEgList = egList.map(e => {
        const id = e.equipment_group_uuid;
        const subName = e.primary_category_name;
        const name = kanban.hasOwnProperty(id) ? kanban[id].name : e.equipment_group_name;
        return ({ equipment_group_uuid: id, equipment_group_name: name, primary_category_name: subName });
    });

    const list = [...oldEgList, ...newEgList];

    return <div className="kanban-filter">
        <MultiSelectAvatar
            className="multi-select-avatar"
            options={list.map(e => ({ id: e.equipment_group_uuid, label: e.equipment_group_name, subLabel: e.primary_category_name }))}
            selected={selected}
            disabled={changedEg}
            onSelect={onSelect}
            maxDisplay={9}
            maxSelection={8}
        />
    </div >;
};

export default EGSelection;
